import {PlayerBase} from "../../player/player.base";
import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {GenericElm} from '../../player/generic.elm';
import {interval, mergeMap, mergeWith, Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError, delay, repeat, tap} from "rxjs/operators";
import {DateUtils} from "../../utils/DateUtiles";

@Component({
  selector: 'app-clock',
  template: '<div #component></div>',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClockComponent extends PlayerBase {
  clockMask;
  genericElm: GenericElm;

  DaysShort = ["Sun", "Mon", "Tue", "Wen", "Thu", "Fri", "Sat"];
  DaysLong = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  MonthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sept", "Oct", "Nov", "Dec"];
  MonthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.genericElm==null) {
          this.genericElm = new GenericElm(this.component);
        }
        const font = this.data.Clock[0].Font[0].$;
        this.genericElm.fontStyle = this.getFontStyle(font);
        this.clockMask = this.data.Clock[0].$.clockMask;
        return this.playerService.caching.requestFont(font);
      }),
      switchMap(a => {
        if (this.editMode) {
          this.genericElm.setText(this.clockMask);
        }
        return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  play(): Observable<any> {
    if (this.editMode) {
      return of(null);
    }
    return super.play().pipe(
      mergeWith(
         of('clock').pipe(
          switchMap( a => this.showTime() ),
          delay(1000),
          repeat()
        )
      )

    )
  }


  showTime() {
    const value = new Date();
    const str = DateUtils.showDate(value, this.clockMask);
    this.genericElm.setText(str);
    return of('time')
  }


  destroy(): void {
    if (this.genericElm != null) {
      this.genericElm.destroy();
    }
    super.destroy();
  }
}
